require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-making-the-transition-from-software-engineer-to-manager.json") })
        }
      }, "path---blog-making-the-transition-from-software-engineer-to-manager");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-making-the-transition-from-software-engineer-to-manager!./.cache/json/blog-making-the-transition-from-software-engineer-to-manager.json
// module id = 928
// module chunks = 231608221292675